import { useEffect } from 'react';
import { useRootDispatch, useRootSelector } from '../../../../store/hooks';
import { selectSiteHeader } from '../../../../store/features/siteHeader';
import { selectSiteContent } from '../../../../store/features/siteContent';
import {
  fetchFestivalProGuests,
  selectFestivalProGuestsMap,
  selectFestivalProGuestsStatus,
} from '../../../../store/features/festivalProGuests';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import GuestCategory from './GuestCategory';
import GuestCategoryNavigation from './GuestCategoryNavigation';
import Spinner from './Spinner';
import ExternalError from './ExternalError';

export const CANCELED_CELEB_TYPE = 'Canceled';

export const categoryNameMapper = {
  Celebrity: 'Celebrities',
  'Animation Voice': 'Animation Voices',
  'Anime Guest': 'Anime Guests',
  'Gaming Star': 'Gaming Stars',
  'Comic Creator': 'Comic Creators',
  'Tattoo Artist': 'Tattoo Artists',
  Cosplayer: 'Cosplayers',
  Author: 'Authors',
  Moderator: 'Moderators',
  [CANCELED_CELEB_TYPE]: 'Cancelled Guests',
};
const categoriesOrder = Object.keys(categoryNameMapper);

export default function FestivalProGuestsView() {
  const dispatch = useRootDispatch();
  const {
    data: { festivalProEventId },
  } = useRootSelector(selectSiteHeader);
  const { details: { pageTitle } = {} } = useRootSelector(selectSiteContent);
  const guestsMap = useRootSelector(selectFestivalProGuestsMap);
  const guestsStatus = useRootSelector(selectFestivalProGuestsStatus);

  useEffect(() => {
    dispatch(fetchFestivalProGuests({ eventId: festivalProEventId }));
  }, [dispatch, festivalProEventId]);

  const sortedCategories = Object.keys(guestsMap)
    .sort((a, b) => {
      const aIndex = categoriesOrder.indexOf(a);
      const bIndex = categoriesOrder.indexOf(b);

      if (aIndex > bIndex) {
        return 1;
      } else if (aIndex < bIndex) {
        return -1;
      }

      return 0;
    })
    .filter((category) => guestsMap[category].length > 0);

  const loading = guestsStatus === 'pending';
  const showError = guestsStatus === 'rejected';
  const showContent = guestsStatus === 'fulfilled';

  return (
    <SiteLayout>
      {loading && <Spinner />}
      {showError && <ExternalError />}
      {showContent && (
        <>
          {sortedCategories.length > 0 && (
            <GuestCategoryNavigation
              heading={pageTitle}
              categories={sortedCategories}
              nameMapper={categoryNameMapper}
            />
          )}
          {sortedCategories.map((category) => (
            <GuestCategory
              key={category}
              category={category}
              heading={categoryNameMapper[category] ?? category}
              guests={guestsMap[category]}
            />
          ))}
        </>
      )}
    </SiteLayout>
  );
}
